import { createClient } from '@/shared/api';
import LOG_AI_BUG_FINAL_BEAT from '@/entities/report/api/mutations/logAiBugFinalBeat';
import type {
  LogAiBugFinalBeatMutation,
  LogAiBugFinalBeatMutationVariables,
} from '@/shared/api/generated/graphql';

export type LogAiBugFinalBeatResult = {
  error: string;
  isSuccess: boolean;
  message: string;
};

// TODO(ts): typed as the LogAiBugFinalBeatInput GraphQL input once its server-side shape is documented
/**
 * Records an AI bug report raised against the final beat data. Runs the logAiBugFinalBeat mutation and returns its field without inspecting the success flag.
 *
 * @param input - Mutation input describing the observed bug.
 * @returns A promise resolving to the logAiBugFinalBeat result.
 */
const handleLogAiBugFinalBeat = async (input: any) => {
  const client = await createClient();
  const result = await client.mutate<LogAiBugFinalBeatMutation, LogAiBugFinalBeatMutationVariables>(
    {
      mutation: LOG_AI_BUG_FINAL_BEAT,
      variables: {
        input,
      },
    },
  );
  const { data } = result;
  const { logAiBugFinalBeat } = data;
  return logAiBugFinalBeat;
};

export default handleLogAiBugFinalBeat;
